<template>
  <div class="field-text" v-if="isVisible">
    <input :id="'form-' + field.form_key" class="form-control w-100"
           type="text"
           v-model="answer"
           :tabIndex="question.id"
           :placeholder="field.placeholder || ''"
           :name="field.form_key"
           autocomplete="on"
           :ref="'field_' + field.form_key"
           @focus="$emit('questionSelected', question.order)"
    >
  </div>
</template>

<script>

import elementMixins from '../mixins/elements'

export default {
  name: 'LUText',
  props: [
    'question',
    'field',
    'answers'
  ],
  mixins: [elementMixins]
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/frontend-vue/components/forms/elements/Text.vue